
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Modal, Box, Typography } from '@mui/material';
import EditUser from './EditUser';
import { AuthContext } from '../context/AuthContext';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const UserList = () => {
    const { auth } = useContext(AuthContext);
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    const handleOpen = (user) => {
        setCurrentUser(user);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentUser(null);
    };

    const handleUpdate = (updatedUser) => {
        setUsers(users.map(user => user.id === updatedUser.id ? updatedUser : user));
    };

    useEffect(() => {
        if (auth.user && auth.user.role === 'root') {
            const fetchUsers = async () => {
                try {
                    const res = await axios.get('/api/users/all');
                    setUsers(res.data);
                } catch (err) {
                    console.error(err.response.data);
                }
            };
            fetchUsers();
        }
    }, [auth.user]);

    const handleDelete = async (id) => {
        try {
            await axios.delete(`/api/users/${id}`);
            setUsers(users.filter(user => user.id !== id));
        } catch (err) {
            console.error(err.response.data);
        }
    };

    if (!auth.user || auth.user.role !== 'root') {
        return (
            <Typography variant="h6" color="error" sx={{ mt: 4, textAlign: 'center' }}>
                У вас нет доступа к этой странице.
            </Typography>
        );
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Имя пользователя</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Роль</TableCell>
                        <TableCell>Иконка</TableCell>
                        <TableCell>Действия</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user) => (
                        <TableRow
                            key={user.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {user.id}
                            </TableCell>
                            <TableCell>{user.username}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.role}</TableCell>
                            <TableCell>{user.icon}</TableCell>
                            <TableCell>
                                <Button variant="contained" color="primary" size="small" sx={{ mr: 1 }} onClick={() => handleOpen(user)}>Редактировать</Button>
                                <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(user.id)}>Удалить</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {currentUser && <EditUser user={currentUser} onClose={handleClose} onUpdate={handleUpdate} />}
                </Box>
            </Modal>
        </TableContainer>
    );
};

export default UserList;
